import { CommonUtils } from "./../../../../../core/src/lib/utils/common.utils";
import { ApprovalService } from "./../../../../../../apps/resource-portal/src/app/services/approval.service";
import { PrivilegeService } from "./../../../../../../apps/resource-portal/src/app/services/privilege.service";
import { ShareRequestDialogComponent } from "./../../../../../../apps/resource-portal/src/app/pages/project/room-by-room/share-request-dialog/share-request-dialog.component";
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  CHANGED_FIELDS,
  CHANGE_TYPES,
  APPROVAL_STATUS,
  EMPTY_GUID,
  REQUEST_ACTION_TYPE,
} from "apps/resource-portal/src/app/constants/app.constant";
import { RoomService } from "apps/resource-portal/src/app/services/room.service";
import { DialogService } from "libs/core/src/lib/services/dialog.service";
import { Subject, takeUntil } from "rxjs";
import { AlertDialogComponent } from "../alert-dialog/alert-dialog.component";
import { ProgressModalComponent } from "../progress-modal/progress-modal.component";
import { ProjectService } from "apps/resource-portal/src/app/services/project.service";
import { AuthService } from "apps/resource-portal/src/app/services/auth.service";
import { debounce } from 'lodash';
@Component({
  selector: "concourse-approval-request",
  templateUrl: "./approval-request.component.html",
  styleUrls: ["./approval-request.component.scss"],
  // encapsulation: ViewEncapsulation.None
})
export class ApprovalRequestComponent implements OnInit, AfterViewInit {
  public departments = [];
  @Input() selectedDepartment = null;
  @Input() approvalStatus = null;
  @Input() selectedRoom = null;
  @Input() sessionId = null;
  @Input() jsnId = null;
  @Input() isRoomTypical = false;
  @Input() useDept = false;
  @Input() projectId: string;
  @Input() projectName: string;
  @Input() isModal: boolean = true;

  @Input() jsnName = null;
  canEdit: boolean = true;
  public rooms = [];
  private $unsubscribe = new Subject();
  changeTypes = CHANGE_TYPES;
  selectedRequests = [];
  sortColumn: string = null;
  emptyGuid = EMPTY_GUID;
  actionType = REQUEST_ACTION_TYPE;
  denyReason: string = null;
  approvalForm: UntypedFormGroup;
  approvalList: UntypedFormArray = new UntypedFormArray([]);
  downloadApprovalList: UntypedFormArray = new UntypedFormArray([]);

  roomName = null;
  commonUtils = CommonUtils;
  selectedCsvOption: number = 0

  totalCount: any = 0;
  page: any = 1;
  pageSize: number = 100;
  pageSizes: number[] = [25, 50, 100, 200];

  allSelected: Boolean = false;
  totalSelected: boolean = false;

  @ViewChild("rejectdialog") rejectDialog!: TemplateRef<any>;
  @ViewChild("csvDownloadDialog") csvDownloadDialog!: TemplateRef<any>;
  csvDownloadDialogModal: any;
  enableActions: boolean = false
  showProjectApproval: boolean = false;
  searchQuery: any = '';
  constructor(
    private _modalService: NgbModal,
    private _roomService: RoomService,
    private _approvalService: ApprovalService,
    private _dialogService: DialogService,
    private privilegeService: PrivilegeService,
    public activeModal: NgbActiveModal,
    private _projectService: ProjectService,
    private _authService: AuthService
  ) {

  }

  searchResults(value) {
    console.log(value);

    this.searchQuery = value;
    this.page = 1;
    this.getApprovalRequests()
    // this.getAllCutsheets(this.page, this.searchStr);
  }
  getUserProjectApproval(projectId) {
    if (!projectId) return
    this._projectService
      .getUserProjectApproval(projectId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        // console.log(result);
        if (result.length > 0) {
          this.showProjectApproval = true
        }
        result.forEach(item => {

          if (this.approvalStatus == APPROVAL_STATUS.PENDING_APPROVAL && item?.approvaltype == 0 && item?.user?.id == this._authService?.user?.contact_id) {
            this.enableActions = true
          }
          if (this.approvalStatus == APPROVAL_STATUS.PENDING_CFG_FINAL_APPROVAL && item?.approvaltype == 1 && item?.user?.id == this._authService?.user?.contact_id) {
            this.enableActions = true
          }
        })

      });
  }

  onPageChange(page: any) {
    if (this.sessionId) {
      this.getApprovalRequestsBySessionId(this.sessionId);
    } else {
      this.getApprovalRequests();
    }
  }

  onPageSizeChange(): void {
    console.log(this.pageSize);

    // this.pageSize = size;
    this.page = 1;
    if (this.sessionId) {
      this.getApprovalRequestsBySessionId(this.sessionId);
    } else {
      this.getApprovalRequests();
    }
  }

  ngOnInit(): void {
    // console.log(this.approvalStatus);
    // console.log("room dept==>", this.selectedRoom, this.selectedDepartment);
    // console.log('project==>',this.projectName);


    switch (this.approvalStatus) {
      case 1:
        this.canEdit = this.hasAccess("PRV_PENDING_REQUEST.EDIT");
        break;
      case 2:
        this.canEdit = this.hasAccess("PRV_PENDING_CFGPM_FINAL_APPROVAL.EDIT");
        break;
      default:
        this.canEdit = false;
        break;
    }

    this.approvalForm = new UntypedFormGroup({
      approvalList: this.approvalList,
    });
    if (this.sessionId) {
      this.getApprovalRequestsBySessionId(this.sessionId);
    } else {
      this.getAllDepartments(this.projectId);
    }
  }

  getApprovalRequestsBySessionId(sessionId: string) {
    this.approvalList.clear();
    // console.log(this.page);

    this._approvalService
      .getApprovalRequestsBySessionId(this.page, this.pageSize, sessionId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        this.totalCount = result?.length;
        if ((this.page - 1) * this.pageSize >= result?.length && this.page > 1) {
          this.page--;
          this.onPageChange(this.page);
        }
        if (result && result.length) {
          this.canEdit = true
          this.approvalStatus = result[0]?.approvalstatus;
          result.forEach((r) => {
            console.log(r);

            this.addNewApprovalList(r);
            this.allSelected = false;
          });
        }
      });
  }

  hasAccess(role: string): boolean {
    return this.privilegeService.userProjectAccess(role, this.projectId);
  }

  openDenyDialog(requests, content) {
    // console.log(requests);

    this.denyReason = "";
    this._modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then((reason) => {
        if (reason) {
          this.confirmRequest(requests, this.actionType.REJECT, reason);
        }
      });
  }

  getAllDepartments(projectId: string) {
    this._roomService
      .getDepartmentByProjectId(projectId, this.isRoomTypical)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.departments = result || [];
          this.departments = CommonUtils.sortByKey(
            this.departments,
            "departmentname"
          );
          if (!this.useDept) {
            this.selectedDepartment = this.emptyGuid;
          }
          if (this.departments.length) {
            // if (!this.selectedDepartment) {
            //   this.selectedDepartment = this.emptyGuid;
            // }
            this.getAllRooms(this.selectedDepartment);
          } else {
            this.selectedDepartment = null;
          }
        }
      });
  }
  openExportCSVDialog(approvalList: any, approvalStatus: any) {

    this.csvDownloadDialogModal = this._modalService.open(this.csvDownloadDialog, {
      size: "md",
      backdrop: "static",
    })
    this.csvDownloadDialogModal.result.then((result) => {
      if (!result) return
      if (+this.selectedCsvOption == 1) {
        if (this.sessionId) {
          this._approvalService
            .getApprovalRequestsBySessionId(null, null, this.sessionId)
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe((result) => {
              result.value.forEach((r) => {
                this.downloadApprovalList.push(
                  new UntypedFormGroup({
                    id: new UntypedFormControl(r?.id || null),
                    isSelected: new UntypedFormControl(false),
                    approvalstatus: new UntypedFormControl(APPROVAL_STATUS[r?.approvalstatus]),
                    changetype: new UntypedFormControl(CHANGE_TYPES[r?.changetype]), //enum
                    jsn: new UntypedFormControl(r?.jsn?.name + (r?.jsn?.other || "")),
                    currentvalue: new UntypedFormControl(r?.currentvalue || ""),
                    requestedvalue: new UntypedFormControl(r?.requestedvalue || ""),
                    nomenclature: new UntypedFormControl(r?.nomenclature || ""),
                    changedescription: new UntypedFormControl(r?.changedescription || ""),
                    changedfield: new UntypedFormControl(r?.changedfield || ""),
                    estimatedcost: new UntypedFormControl(r?.estimatedcost),
                    project: new UntypedFormControl(this.projectName),
                    department: new UntypedFormControl(r?.department?.name),
                    room: new UntypedFormControl(r?.room?.name),
                    roomId: new UntypedFormControl(r?.room?.id),
                  })
                );
              });
              // console.log('result==>', this.downloadApprovalList.value);

              this.commonUtils.JSONToCSVConvertor(
                this.downloadApprovalList.value,
                approvalStatus,
                true
              );
              this.selectedCsvOption = 0;

            });
        } else {
          this._approvalService
            .getApprovalRequests(
              null,
              null,
              '',
              this.selectedDepartment,
              this.selectedRoom,
              this.approvalStatus,
              this.projectId,
              this.jsnId
            )
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe((result) => {
              result.value.forEach((r) => {
                this.downloadApprovalList.push(
                  new UntypedFormGroup({
                    id: new UntypedFormControl(r?.id || null),
                    isSelected: new UntypedFormControl(false),
                    approvalstatus: new UntypedFormControl(APPROVAL_STATUS[r?.approvalstatus]),
                    changetype: new UntypedFormControl(CHANGE_TYPES[r?.changetype]), //enum
                    jsn: new UntypedFormControl(r?.jsn?.name + (r?.jsn?.other || "")),
                    currentvalue: new UntypedFormControl(r?.currentvalue || ""),
                    requestedvalue: new UntypedFormControl(r?.requestedvalue || ""),
                    nomenclature: new UntypedFormControl(r?.nomenclature || ""),
                    changedescription: new UntypedFormControl(r?.changedescription || ""),
                    changedfield: new UntypedFormControl(r?.changedfield || ""),
                    estimatedcost: new UntypedFormControl(r?.estimatedcost),
                    project: new UntypedFormControl(this.projectName),
                    department: new UntypedFormControl(r?.department?.name),
                    room: new UntypedFormControl(r?.room?.name),
                    roomId: new UntypedFormControl(r?.room?.id),
                  })
                );
              });
              // console.log('result==>', this.downloadApprovalList.value);

              this.commonUtils.JSONToCSVConvertor(
                this.downloadApprovalList.value,
                approvalStatus,
                true
              );
              this.selectedCsvOption = 0;

            });
        }
      }
      else if (+this.selectedCsvOption == 2) {
        this.commonUtils.JSONToCSVConvertor(
          this.selectedRequests,
          approvalStatus,
          true
        );
        this.selectedCsvOption = 0;

      }
      else {
        // console.log('result==>', approvalList);

        this.commonUtils.JSONToCSVConvertor(
          approvalList,
          approvalStatus,
          true
        );
        this.selectedCsvOption = 0;
      }
    })
  }

  getAllRooms(departmentId: string) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment == EMPTY_GUID) {
      this.selectedRoom = EMPTY_GUID;
      this.getRequests(this.selectedRoom);
    }
    this._roomService
      .getRoomsByDepartmentId(departmentId, this.isRoomTypical)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.rooms = result || [];
          this.rooms = CommonUtils.sortByKey(this.rooms, "name");
          if (this.rooms.length) {
            if (!this.selectedRoom) {
              this.selectedRoom = EMPTY_GUID;
              // this.getApprovalRequests();
            }
            this.getRequests(this.selectedRoom);
          } else {
            this.selectedRoom = null;
          }
        }
      });
  }

  getRequests(roomId: string) {
    this.selectedRoom = roomId;
    this.getApprovalRequests();
  }

  getRoomMetaData(id, key) {
    if (id && this.selectedRoom && this.rooms && this.rooms.length > 0) {
      let roomData = this.rooms.find((room) => {
        return room.id == id;
      })[key];
      return roomData;
    }
  }
  resolveTimeout(value, delay) {
    return new Promise((resolve) => setTimeout(() => resolve(value), delay));
  }

  async confirmRequest(requests, actiontype, reason?) {
    console.log(this.totalSelected, this.sessionId);

    if (this.totalSelected) {
      if (this.sessionId) {
        this._approvalService
          .getApprovalRequestsBySessionId(null, null, this.sessionId)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            if (result && result.value && result.value.length) {
              this.approvalStatus = result.value[0]?.approvalstatus;
              this.approvalLoop(result.value, actiontype);
            }
          });
      } else {
        console.log(this.selectedDepartment,
          this.selectedRoom,
          this.approvalStatus,
          this.projectId,
          this.jsnId);
        this._approvalService
          .getApprovalRequests(
            null,
            null,
            '',
            this.selectedDepartment,
            this.selectedRoom,
            this.approvalStatus,
            this.projectId,
            this.jsnId
          )
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            this.totalCount = result.count;
            if (
              (this.page - 1) * this.pageSize >= result.count &&
              this.page > 1
            ) {
              this.page--;
              this.onPageChange(this.page);
            }
            if (result && result.value && result.value.length) {
              this.approvalStatus = result.value[0]?.approvalstatus;
              this.approvalLoop(result.value, actiontype);
            }
          });
      }
    } else {
      if (requests[0]?.roomId) {
        this.selectedRoom = requests[0]?.roomId;
      }
      const modalRef = this._modalService.open(AlertDialogComponent, {
        size: "md",
        backdrop: "static",
      });
      modalRef.componentInstance.title = `${actiontype == this.actionType.APPROVE ? "Approve" : "Deny"
        } Request`;
      modalRef.componentInstance.message1 = `Are you sure you want to ${actiontype == this.actionType.APPROVE ? "approve" : "deny"} ${requests.length > 1 ? "selected requests" : "this request"
        } ?`;
      modalRef.componentInstance.yes_label = `Yes, ${actiontype == this.actionType.APPROVE ? "Approve" : "Deny"
        } changes`;
      modalRef.componentInstance.no_label = "No, Cancel";
      // modalRef.componentInstance.closeBtn = true;
      modalRef.result.then(async (data) => {
        if (data == "success") {
          let progressModal;
          // if (requests.length > 1) {
          progressModal = this._modalService.open(ProgressModalComponent, {
            size: "md",
            backdrop: "static",
          });
          progressModal.componentInstance.processing = 1;
          // patch to fix 11 count
          progressModal.componentInstance.total = requests.length;
          // }
          for (let i = 0; i < requests.length; i++) {
            try {
              await this.processSingleRequest(
                actiontype,
                requests[i],
                reason
              ).then((res: any) => {
                if (i == requests.length - 1) {
                  this._dialogService.showToast(res?.message, "success");
                }
              });
              await this.resolveTimeout(0, 500);
              if (i == requests.length - 1) {
                if (this.sessionId) {
                  this.getApprovalRequestsBySessionId(this.sessionId);
                  progressModal.componentInstance.processing = 2;
                  progressModal.close();
                } else {
                  progressModal.componentInstance.processing = 2;
                  this.getApprovalRequests();
                  progressModal.close();
                }
              }
            } catch (err) {
              this._dialogService.showToast("Approval failed", "error");
              continue;
            } finally {
              progressModal.componentInstance.approved++;
            }
          }
        }
      });
    }
  }

  async processSingleRequest(actiontype, request, reason?) {
    return new Promise((resolve, reject) => {
      let params = {
        approvalstatus:
          // actiontype == APPROVAL_STATUS.APPROVED ,
          actiontype == APPROVAL_STATUS.APPROVED ? this.approvalStatus + 1 : 4,
        reason: reason,
        estimatedcost: request?.estimatedcost,
        changedescription: request?.changedescription,
        department: this.selectedDepartment,
        room: this.selectedRoom,
        project: this.projectId,
      };
      this._approvalService
        .processRequest(request?.id, params)
        .pipe(takeUntil(this.$unsubscribe))
        .subscribe(
          (result) => {
            if (result && result?.status == 200) {
              // this._dialogService.showToast(result?.message, "success");
              // this.getApprovalRequests();
              resolve(result);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  addNewApprovalList(content) {
    this.approvalList.push(
      new UntypedFormGroup({
        id: new UntypedFormControl(content?.id || null),
        isSelected: new UntypedFormControl(false),
        approvalstatus: new UntypedFormControl(content?.approvalstatus),
        changetype: new UntypedFormControl(CHANGE_TYPES[content?.changetype]), //enum
        jsn: new UntypedFormControl(content?.jsn?.name + (content?.jsn?.other || "")),
        currentvalue: new UntypedFormControl(content?.currentvalue || ""),
        requestedvalue: new UntypedFormControl(content?.requestedvalue || ""),
        nomenclature: new UntypedFormControl(content?.nomenclature || ""),
        changedescription: new UntypedFormControl(content?.changedescription || ""),
        changedfield: new UntypedFormControl(content?.changedfield || ""),
        estimatedcost: new UntypedFormControl(content?.estimatedcost),
        project: new UntypedFormControl(this.projectName),
        department: new UntypedFormControl(content?.department?.name),
        room: new UntypedFormControl(content?.room?.name),
        roomId: new UntypedFormControl(content?.room?.id),
      })
    );
  }

  updateApprovalRequest(requestId) {
    //console.log(requestId, field);
    let request = this.approvalList.value.find((t) => t.id == requestId);
    let params = {
      approvalstatus: request.approvalstatus,
      estimatedcost: request.estimatedcost,
      changedescription: request.changedescription,
    };
    // console.log(requestId, params);
    this._approvalService
      .processRequest(requestId, params)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        console.log(result);
      });
  }

  get getApprovalForm(): UntypedFormArray {
    return this.approvalForm.get("approvalList") as UntypedFormArray;
  }

  getApprovalRequests() {
    this.approvalList.clear();
    if (JSON.parse(localStorage.getItem("isFromCutsheet"))) {
      this.selectedRoom = EMPTY_GUID;
    }
    if (this.selectedDepartment === EMPTY_GUID) {
      this.selectedRoom = EMPTY_GUID;
    }
    // console.log(this.selectedDepartment);

    this._approvalService
      .getApprovalRequests(
        this.page,
        this.pageSize,
        this.searchQuery,
        this.selectedDepartment,
        this.selectedRoom,
        this.approvalStatus,
        this.projectId,
        this.jsnId,
      )
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        this.totalCount = result.count;
        if ((this.page - 1) * this.pageSize >= result.count && this.page > 1) {
          this.page--;
          this.onPageChange(this.page);
        }
        if (result && result.value && result.value.length) {
          result.value.forEach((r) => {
            this.addNewApprovalList(r);
            this.allSelected = false;
          });
        }
      });
  }

  getChangeType(type) {
    return CHANGE_TYPES[type];
  }

  getTotalEstimation() {
    let list = this.approvalForm.get("approvalList").value;
    let val = 0;
    for (let x = 0; x < list.length; x++) {
      val += Number(list[x].estimatedcost);
    }
    return val;
  }

  approveSelectedRequests() {
    console.log(this.selectedRequests);
  }

  sortByColumn(arr, columnName, order) {
    this.sortColumn = columnName;
    arr = CommonUtils.sortByKey(arr, columnName, order ? "ASC" : "DESC");
  }

  shareRequest() {
    if (this.selectedRequests.length && this.approvalList.length) {
      const modelRef = this._modalService.open(ShareRequestDialogComponent, {
        centered: true,
        size: "sm",
        windowClass: "modal-class",
        backdrop: "static",
        keyboard: false,
      });
      modelRef.componentInstance.projectId = this.projectId;
      modelRef.componentInstance.selectedRequests = this.selectedRequests;
      modelRef.result.then((data) => {
        if (data && data?.status == 200) {
          this._dialogService.showToast(data.message, "success");
        }
      });
    }
  }

  selectAll(event) {
    this.approvalList.controls.forEach((approval) => {
      approval.get("isSelected").setValue(event.target.checked);
      if (!event.target.checked) {
        this.totalSelected = false
      }
    });
  }

  ngAfterViewInit(): void {

    this.approvalList.valueChanges.subscribe((res) => {
      this.selectedRequests = res.filter((t) => t.isSelected);
    });
    this.getUserProjectApproval(this.projectId);
  }
  async approvalLoop(array: any, actiontype: any) {
    const modalRef = this._modalService.open(AlertDialogComponent, {
      size: "md",
      backdrop: "static",
    });
    modalRef.componentInstance.title = "Process Approvals";

    modalRef.componentInstance.message1 = `Are you sure you want to ${actiontype == this.actionType.APPROVE ? "approve" : "deny"} ${array.length > 1 ? `selected ${array.length} requests` : "this request"
      } ?`;
    modalRef.componentInstance.yes_label = `Yes, ${actiontype == this.actionType.APPROVE ? "Approve" : "Deny"
      } changes`;
    modalRef.componentInstance.no_label = "No, Cancel";

    // modalRef.componentInstance.message1 = `What you want to do with selected ${array.length} records ?`;
    // modalRef.componentInstance.yes_label = "Approve";
    // modalRef.componentInstance.no_label = "Deny";
    modalRef.componentInstance.closeBtn = true;
    modalRef.result.then(async (data) => {
      if (data == "success") {
        let progressModal;
        // if (requests.length > 1) {
        progressModal = this._modalService.open(ProgressModalComponent, {
          size: "md",
          backdrop: "static",
        });
        progressModal.componentInstance.processing = 1;
        progressModal.componentInstance.total = array.length;
        // }
        for (let i = 0; i < array.length; i++) {
          try {
            await this.processSingleRequest(
              actiontype,
              array[i]
            ).then((res: any) => {
              if (i == array.length - 1) {
                this._dialogService.showToast(res?.message, "success");
              }
            });
            await this.resolveTimeout(0, 500);
            if (i == array.length - 1) {
              if (this.sessionId) {
                this.getApprovalRequestsBySessionId(this.sessionId);
                progressModal.componentInstance.processing = 2;
                progressModal.close();
              } else {
                progressModal.componentInstance.processing = 2;
                this.getApprovalRequests();
                progressModal.close();
              }
            }
          } catch (err) {
            this._dialogService.showToast("Approval failed", "error");
            continue;
          } finally {
            progressModal.componentInstance.approved++;
          }
        }
      } else if (data == "cancel") {
        // this.openDenyDialog(array, this.rejectDialog);
      }
    });
  }
  selectTotal() {
    this.totalSelected = true;
  }
  get startIndex(): number {
    return (this.page - 1) * this.pageSize + 1;
  }

  get endIndex(): number {
    const end = this.page * this.pageSize;
    return end > this.totalCount ? this.totalCount : end;
  }
}
